import {
  TopAppBarActionItem,
  TopAppBarRow,
  TopAppBarSection,
  TopAppBarTitle,
} from "@rmwc/top-app-bar";
import domClass from "dojo/dom-class";
import query from "dojo/query";
import React, { useContext } from "react";
import { ApplicationName, ApplicationSubTitle } from "../appConfig";
import { AppContext } from "../contexts/App";
//import { Authentication } from "./Authentication";
//import DirectionsSummary from "./DirectionsSummary";
import { NavToList, NavToMap } from "./Nav";
import TopAppBarContainer from "./styled/TopAppBarContainer";

const navs = (mode: string) => {
  const nav: JSX.Element | [] = []; //mode === "map" ? <NavToList icon={"navigate_before"} /> : [];
  const mapOrList =
    mode === "list" ? (
      <NavToMap />
    ) : (
      <NavToList icon={"format_list_bulleted"} />
    );

  return [nav, mapOrList];
};

const AppBar = () => {
  const { state, setState } = useContext(AppContext);
  const { mode } = state;
  const [nav, mapOrList] = mode === "normal" ? [null, null] : navs(mode);

  const toggleShareMUGIS = () => {
    setState({
      shareMUGIS: !state.shareMUGIS,
    });
  };
  const printButtonClicked = () => {

    var elements = document.getElementsByClassName("active");
    for (var i = 0; i < elements.length; i++) {
      elements[i].classList.remove("active");
    }
    let visiblePanels = query(".esri-widget--panel.slidein");
    visiblePanels.forEach((item: any) => {
      domClass.remove(item, "slidein");
      domClass.add(item, "slideout");
    });


    if (document.getElementById("printContainer")) {
      if (domClass.contains("printContainer", "slideout")) {
        domClass.remove("printContainer", "slideout");
        domClass.add("printContainer", "slidein");
      } else {
        domClass.remove("printContainer", "slidein");
        domClass.add("printContainer", "slideout");
      }
    }


  }
  const content = (
    <TopAppBarRow>
      <TopAppBarSection alignStart>
        {nav}
        <div className="toolbar__leading-icon"></div>
        <TopAppBarTitle>
          <div dangerouslySetInnerHTML={{ __html: ApplicationName }}></div>
          <div className="toolbar__subTitle">{ApplicationSubTitle}</div>
        </TopAppBarTitle>
      </TopAppBarSection>
     
      <TopAppBarSection alignEnd>
        {/* <Authentication /> */}
        {mode === "normal" && <TopAppBarActionItem
          id={"printMUGISActionItem"}
          icon="print"
          title="Print Map"
          onClick={printButtonClicked} //THIS IS FAKE CONTROL the actual control is the PrintControl button that loads the widget but is hidden//BANDAID --fix later
        ></TopAppBarActionItem>}
        <TopAppBarActionItem
          id={"shareMUGISActionItem"}
          icon="share"
          title="Share"
          onClick={toggleShareMUGIS}
        ></TopAppBarActionItem>
        {mapOrList}
      </TopAppBarSection>
    </TopAppBarRow>
  );

  return <TopAppBarContainer mode={mode}>{content}</TopAppBarContainer>;
};

export default AppBar;
